"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateShortGuid = exports.generateGuid = void 0;
/**
 * generuje guid w formacie xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 * @param format N - bez kresek, B - z klamrami, P - z nawiasami
 */
function generateGuid(format) {
    var g = format == 'N' ? 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx' : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    var result = g.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    switch (format) {
        case 'B':
            return '{' + result + '}';
        case 'P':
            return '(' + result + ')';
    }
    return result;
}
exports.generateGuid = generateGuid;
var h16a = '0123456789abcdef'.split('');
/**
 * generuje skrócony guid 12 znaków
 */
function generateShortGuid() {
    var s = '';
    for (var i = 0; i < 12; i++)
        s += h16a[(Math.random() * 16) | 0];
    return s;
}
exports.generateShortGuid = generateShortGuid;
//# sourceMappingURL=generateGuid.js.map